import {
  ApiDependencyProviderService,
  CollectionRequest,
  CollectionResponse,
} from '@web/common';
import { map, Observable } from 'rxjs';
import { valueOrDefault } from '@web/utils';
import { Injectable, inject } from '@angular/core';
import { PublicFaqCategoryCollectionItemResponse } from '../responses/public-faq-category-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class PublicFaqPageApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchCollection(
    request: CollectionRequest,
    options?: { cacheable?: boolean },
  ): Observable<CollectionResponse<PublicFaqCategoryCollectionItemResponse>> {
    const path = `faq/category`;
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      this.provider.httpHelper.collectionRequestToQueryParams(request),
    );
    const context = this.provider.httpContextBuilder
      .skipByAuthTokenInterceptor()
      .skipByLoadingInterceptor()
      .skipByHttpErrorInterceptor()
      .withOptionalCacheInterceptor(() =>
        valueOrDefault(options?.cacheable, false),
      )
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToCollectionResponse(
            PublicFaqCategoryCollectionItemResponse,
          ),
        ),
      );
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
